const SERVICE_UUID = '6c6f0001-fb01-4e58-9a01-666c75696462';
const CHAR_SSID = '6c6f0002-fb01-4e58-9a01-666c75696462';
const CHAR_PASSWORD = '6c6f0003-fb01-4e58-9a01-666c75696462';
const CHAR_CONTROL = '6c6f0004-fb01-4e58-9a01-666c75696462';
const CHAR_STATUS = '6c6f0005-fb01-4e58-9a01-666c75696462';
const CHAR_SCAN = '6c6f0006-fb01-4e58-9a01-666c75696462';

const CONTROL = {
  COMMIT: 0x01,
  FORGET: 0x02,
  SCAN: 0x03,
  END: 0x04,
};

const STATUS_STATES = [
  'wait_pin',
  'scanning',
  'connecting',
  'got_ip',
  'bad_pin',
  'fail',
  'saved',
  'idle',
];

const ANDROID_ONLY_MESSAGE =
  'FluidBox Wi-Fi setup needs an Android phone with Chrome. iPhone is not supported.';

const CONNECT_TIMEOUT_MS = 30000;
const COMMIT_TIMEOUT_MS = 20000;

function canUseWebBluetooth(globalObj = globalThis) {
  return Boolean(
    globalObj.isSecureContext &&
    globalObj.navigator &&
    globalObj.navigator.bluetooth &&
    typeof globalObj.navigator.bluetooth.requestDevice === 'function',
  );
}

function fluidBoxRequestDeviceOptions() {
  return {
    filters: [{ namePrefix: 'FluidBox-' }, { services: [SERVICE_UUID] }],
    optionalServices: [SERVICE_UUID],
  };
}

function encodeUtf8(str) {
  return new TextEncoder().encode(String(str ?? ''));
}

function decodeUtf8(value) {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value instanceof DataView) {
    return new TextDecoder().decode(
      new Uint8Array(value.buffer, value.byteOffset, value.byteLength),
    );
  }
  return new TextDecoder().decode(value);
}

function digitsOnly(pin) {
  return String(pin || '')
    .replace(/\D/g, '')
    .slice(0, 4);
}

function encodePasswordPayload(pin, password) {
  return encodeUtf8(`${digitsOnly(pin)}\n${password || ''}`);
}

function parseStatusJson(text) {
  try {
    const parsed = JSON.parse(text);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }
    return {
      state: typeof parsed.state === 'string' ? parsed.state : '',
      ssid: typeof parsed.ssid === 'string' ? parsed.ssid : '',
      rssi: Number(parsed.rssi) || 0,
      ip: typeof parsed.ip === 'string' ? parsed.ip : '',
      err: typeof parsed.err === 'string' ? parsed.err : '',
    };
  } catch {
    return null;
  }
}

function parseScanJson(text) {
  try {
    const parsed = JSON.parse(text);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((row) => row && typeof row.s === 'string')
      .map((row) => ({ s: row.s, r: Number(row.r) || 0 }));
  } catch {
    return [];
  }
}

function statusLabel(status) {
  if (!status || !status.state) return '';
  switch (status.state) {
    case 'wait_pin':
      return 'Waiting — enter the PIN shown on the FluidBox.';
    case 'scanning':
      return 'Scanning for networks…';
    case 'connecting':
      return 'Connecting…';
    case 'got_ip':
      return status.ip
        ? `Connected to ${status.ssid || 'Wi-Fi'} (${status.ip})`
        : `Connected to ${status.ssid || 'Wi-Fi'}`;
    case 'bad_pin':
      return 'Wrong PIN. Check the FluidBox screen and try again.';
    case 'fail':
      return status.err
        ? `Failed: ${status.err}`
        : 'Could not join that network.';
    case 'saved':
      return 'Credentials saved.';
    case 'idle':
      return 'Ready.';
    default:
      return status.state;
  }
}

/** BLE often drops once the FluidBox joins Wi-Fi, before a got_ip notify arrives. */
function bleDropMeansWifiJoined(ctx) {
  if (!ctx || ctx.closed || ctx.success || !ctx.commitSent) return false;
  return ctx.state !== 'bad_pin' && ctx.state !== 'fail';
}

function chooserErrorMessage(err) {
  const name = err && err.name;
  const message = (err && err.message) || '';
  if (name === 'NotFoundError' && /cancel/i.test(message)) {
    return 'Bluetooth chooser was closed.';
  }
  if (name === 'NotFoundError') {
    return 'No FluidBox found. On the device, open Settings → Wi-Fi setup and try again.';
  }
  if (name === 'NotAllowedError' || name === 'SecurityError') {
    return 'Bluetooth permission was denied.';
  }
  if (name === 'NetworkError') {
    return 'Lost the Bluetooth connection.';
  }
  return message || 'Bluetooth error.';
}

module.exports = {
  ANDROID_ONLY_MESSAGE,
  CHAR_CONTROL,
  CHAR_PASSWORD,
  CHAR_SCAN,
  CHAR_SSID,
  CHAR_STATUS,
  COMMIT_TIMEOUT_MS,
  CONNECT_TIMEOUT_MS,
  CONTROL,
  SERVICE_UUID,
  STATUS_STATES,
  bleDropMeansWifiJoined,
  canUseWebBluetooth,
  chooserErrorMessage,
  decodeUtf8,
  digitsOnly,
  encodePasswordPayload,
  encodeUtf8,
  fluidBoxRequestDeviceOptions,
  parseScanJson,
  parseStatusJson,
  statusLabel,
};
